import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App' 
import { ChakraProvider, defaultSystem,  } from '@chakra-ui/react'
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './auth/AuthContext' 
import { Provider as PermissionsProvider } from './permissions'
import AppProvider from './context'
import './index.css'
import './i18n'

// Auto-reload once when a lazy chunk fails to load after a redeployment.
// Without this, users see a blank screen until they manually refresh.
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const msg: string = event.reason?.message ?? ''
  const isChunkError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    event.reason?.name === 'ChunkLoadError'

  if (isChunkError) {
    const RELOAD_KEY = 'chunk_reload_at'
    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
    // Guard: only reload once per 15 seconds to avoid infinite loops
    if (Date.now() - lastReload > 15_000) {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
      window.location.reload()
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <ChakraProvider value={defaultSystem}>
    <StrictMode>
      <HelmetProvider>
        <AuthProvider>
          <PermissionsProvider>
            <AppProvider>
              <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                <App />
              </Router>
            </AppProvider>
          </PermissionsProvider>
        </AuthProvider>
      </HelmetProvider>
    </StrictMode>
  </ChakraProvider>,
)
